import React, {Component} from 'react';
import axios from 'axios';
import '../tools/css/Ajustes.css';
import Date from '../components/DataPicker';
import BtnSave from '../components/BtnSave';
import BtnCancel from '../components/BtnCancel';

import ReactNotifications from 'react-notifications-component';
import { store } from 'react-notifications-component';
import 'animate.css';
import 'react-notifications-component/dist/theme.css';
import $ from 'jquery'; // <-to import jquery
import 'bootstrap';

var mensaje='';

// Accesos directos a las configuraciones básicas del portal. Los mismos
// destinos que ya usaba esta vista, agrupados por tema para que se
// entienda de un vistazo qué se configura en cada sección.
const GRUPOS_AJUSTES = [
  {
    titulo: 'Atención y agenda',
    opciones: [
      { titulo: 'Horarios de atención', descripcion: 'Define tus horarios y tiempos de espera para las citas.', icono: 'fa-clock', ruta: '/horarios' },
      { titulo: 'Agendas', descripcion: 'Crea y organiza las agendas de tus profesionales.', icono: 'fa-calendar-alt', ruta: '/agendas' },
      { titulo: 'Sedes', descripcion: 'Administra las sedes o sucursales de tu institución.', icono: 'fa-hospital', ruta: '/sedes' }
    ]
  },
  {
    titulo: 'Servicios y facturación',
    opciones: [
      { titulo: 'Servicios', descripcion: 'Registra los servicios médicos que ofrece tu institución.', icono: 'fa-stethoscope', ruta: '/servicios_facturacion' },
      { titulo: 'Convenios', descripcion: 'Gestiona los convenios con entidades y aseguradoras.', icono: 'fa-handshake', ruta: '/convenios' },
      { titulo: 'Cuota moderadora', descripcion: 'Configura los valores de copago de tus servicios.', icono: 'fa-coins', ruta: '/cuotasmoderadoras' }
    ]
  },
  {
    titulo: 'Documentos y usuarios',
    opciones: [
      { titulo: 'Contratos', descripcion: 'Gestiona los contratos con instituciones y aseguradoras.', icono: 'fa-file-contract', ruta: '/contratos' },
      { titulo: 'Consentimientos', descripcion: 'Administra los consentimientos informados de tus pacientes.', icono: 'fa-file-signature', ruta: '/consentimientos' },
      { titulo: 'Usuarios', descripcion: 'Crea y administra los usuarios que acceden a tu portal.', icono: 'fa-users-cog', ruta: '/crear_usuarios' }
    ]
  },
  {
    titulo: 'Historia clínica',
    opciones: [
      { titulo: 'Crear y configurar historias clínicas', descripcion: 'Arma los formularios de historia clínica que van a diligenciar tus profesionales.', icono: 'fa-file-medical-alt', ruta: '/config_historia_clinica' },
      { titulo: 'Editar configuración de historias clínicas', descripcion: 'Revisa, edita o desactiva las historias clínicas que ya has configurado.', icono: 'fa-edit', ruta: '/historias_clinicas_configuradas' }
    ]
  }
]


class Ajustes extends Component {

  constructor()
    {
     super()
      this.state={
        show:false
      }
    }

    componentDidMount(){

      $('[data-toggle="tooltip"]').tooltip()

    }

    handleModalnewcontrato()
    {
      this.setState({show:!this.state.show})
      $('#modal-newcontrato').modal('show'); // <- to show modal crear contrato
    }

    handleModaleditcontrato()
    {
      this.setState({show2:!this.state.show2})
      $('#modal-editcontrato').modal('show'); // <- to show modal editar contrato
    }

    saverecurso=async()=>{

        await axios.get("https://video.twilio.com/v1/Compositions/CJ6186488b9d6f44f85ae2ed6b490fb7b7/Media?Ttl=3600",{
          headers: {'Authorization': 'Basic '+"U0s4ZGM4YzZhYzlmMmM5ZTdhNmNiOWJmNDhlYTc3MTUyNjpTQmFxNktYSVh6UFF4NjZEaEVyejNFVTV5MG80bXRtNg=="
        }
        })

        .then(response=>{
          console.log(response.data)

          mensaje  = response.data.message;

          //this.setState({
            //Type_servicenew:response.data.agreement.typeServiceAgreements,
            //Servi_convenionew:response.data.agreement.serviceAgreements
          //})
          //alert(dato);
          //const [text, setText] = LocalStorage(text, '')
          //setText(dato);

          //window.location.href="/home";
          store.addNotification({
            title: 'Muy bien',
            message: mensaje,
            type: 'success',                         // 'default', 'success', 'info', 'warning', 'danger'
            container: 'top-right',                // where to position the notifications
            animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
            animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
            dismiss: {
              duration: 10000,
              showIcon:true
            }
          })


        })
        .catch(error=>{

          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            //console.log(error.response.data.message);
            //console.log(error.response.status);
            //console.log(error.response.headers);
            mensaje=error.response.data.message

            store.addNotification({
              title: 'Error',
              message: mensaje,
              type: 'danger',                         // 'default', 'success', 'info', 'warning', 'danger'
              container: 'top-right',                // where to position the notifications
              animationIn: ["animated", "fadeIn"],     // animate.css classes that's applied
              animationOut: ["animated", "fadeOut"],   // animate.css classes that's applied
              dismiss: {
                duration: 10000,
                showIcon:true
              }
            })

        } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            console.log(error.request);
        } else {
            // Something happened in setting up the request and triggered an Error
            console.log('Error', error.message);
        }
        //console.log(error.config);

      })


     }


    render(){

     return (

      <div className="content-wrapper ajustes-root">

        <div className="col-12 col-sm-12">

          <div className="ajustes-header">
            <div className="ajustes-header__icono"><i className="fas fa-sliders-h"></i></div>
            <div className="ajustes-header__texto">
              <h1 className="ajustes-header__titulo">Ajustes</h1>
              <p className="ajustes-header__subtitulo">
                Este apartado reúne las configuraciones básicas de tu portal, selecciona una sección para
                empezar a configurarla.
              </p>
            </div>
          </div>

          {GRUPOS_AJUSTES.map((grupo) => (
            <div className="ajustes-grupo" key={grupo.titulo}>
              <h2 className="ajustes-grupo__titulo">{grupo.titulo}</h2>
              <div className="ajustes-grid">
                {grupo.opciones.map((opcion) => (
                  <a className="ajustes-card" href={opcion.ruta} key={opcion.ruta}>
                    <div className="ajustes-card__icono"><i className={"fas " + opcion.icono}></i></div>
                    <div className="ajustes-card__texto">
                      <span className="ajustes-card__titulo">{opcion.titulo}</span>
                      <span className="ajustes-card__desc">{opcion.descripcion}</span>
                    </div>
                    <i className="fas fa-chevron-right ajustes-card__flecha"></i>
                  </a>
                ))}
              </div>
            </div>
          ))}

        </div>

      </div>

    )

  }

}



export default Ajustes;
